import React from 'react';
import { DefaultButton, Stack, Text } from 'office-ui-fabric-react';
export var TodoFooter = function (props) {
    var itemCount = Object.keys(props.todos).filter(function (id) { return !props.todos[id].completed; }).length;
    // TODO: play around with the DefaultButton component below with a "styles" prop
    // - try it with an object: styles={{ ... }}
    // - try it with a function: styles={props => ({ ... })}
    return (React.createElement(Stack, { horizontal: true, horizontalAlign: "space-between", verticalAlign: "center" },
        React.createElement(Text, null,
            itemCount,
            " item",
            itemCount === 1 ? '' : 's',
            " left"),
        React.createElement(DefaultButton, { onClick: function () { return props.clear(); } }, "Clear Completed")));
};
